import _ from "lodash";
import queryString from "query-string";
import lottie from "lottie-web";
import moment from "moment";
import base64js from "base64-js";
import i18next, { t } from "i18next";
import {
  isAndroid,
  isIOS,
  isTablet,
  isMobile,
  isBrowser,
  isDesktop,
} from "react-device-detect";
// import amplitude from 'amplitude-js';

import { URL, TYPE, PROP } from "../constant";
import { URL as TEST_URL } from "../constant/TEST_URL";
import { store } from "../components/provider/ReduxProvider";
import translationKO from "../i18n/locales/ko/translation.json";
import axios from "axios";

export const getParam = (pathParams, pName) => {
  let params = pathParams.substr(pathParams.indexOf("?") + 1);
  let sval = pName ?  "" : {};

  
  params = params.split("&");
  
  for (let i = 0; i < params.length; i++) {
    const temp = params[i].split("=");
    
    if (pName && temp[0] === pName) {
      sval = temp[1];
    } else {
      sval = Object.assign(sval, { [temp[0]]: temp[1] });
    }
  }

  return sval;
};

export const getUrlParams = (appParams) => {
  let result = {};

  if (!appParams) return;
  appParams.replace(/[?&]+([^=&]+)=([^&]*)/gi, 
    function(str, key, value) { 
        result[key] = value; 
      }
  ); 
  
  return result;
}

export const getDataFormApp = () => {
  const params = window.location.search;
  const pathname = window.location.pathname;

  let parsed = null;
  let data = {
    entryType: "",
    contract: "",
    pMember: "",
    cMember: "",
    cntrtNo: "",
    appId: "",
  };
  // localhost 테스트
  if (!params) {
    switch (true) {
      case _.includes(URL.QUESTION_INSPECTION, pathname):
      case _.includes(pathname, URL.SAMPLE):
      case _.includes(pathname, URL.WORK_SHEET):
        break;
      default:
        // app에서 들어올 때 url params가 없을 때 운영은 앱 종료
        if (
          process.env.REACT_APP_ENV === "production" ||
          process.env.REACT_APP_ENV === "development"
        ) {
          if (process.env.REACT_APP_ENV === "development") {
            // 검증 테스트 용 parameter
            const devUrl = sessionStorage.getItem("devurl") || TEST_URL.GB_APP;
            parsed = queryString.parse(devUrl.split("?")[1]);
          } else {
          }
        } else {
          const devUrl = sessionStorage.getItem("devurl") || TEST_URL.GB_APP;
          parsed = queryString.parse(devUrl.split("?")[1]);
        }
    }
  } else {
    localStorage.setItem("gb_app_params", params);

    parsed = queryString.parse(params);
  }

  if (parsed?.CHN_CD === TYPE.CHANNEL.GLOBAL01) {
    let locale = parsed.LOCALE.toUpperCase();
    if (locale !== "KO" && locale !== "EN") {
      locale = "EN";
    }
    localStorage.setItem("locale", locale);
  } else {
    const locale = localStorage.getItem("locale");
    localStorage.setItem("locale", locale ? locale : "KO");
  }

  if (parsed) {
    if (parsed?.ENTER_TYPE) {
      // 스마트올 APP 진입 시
      data = {
        pathname: pathname,
        entryType: parsed?.ENTER_TYPE,
        chnCd: parsed.ENTER_TYPE,
        pMember: parsed?.PMEMBER_CODE,
        cMember: parsed?.CMEMBER_CODE,
        contract: parsed?.CONTRACT_NUMBER,
        pmCheck: parsed?.PM_CHECK,
        url: parsed?.URL,
      };
    } else {
      // 스마트올 그 외 APP 진입 시
      data = {
        pathname: pathname,
        entryType: parsed?.LAUNCH_TYPE,
        chnCd: parsed.CHN_CD,
        cntrtNo: parsed?.CNTRT_NO,
        // contract: parsed?.CONTRACT_NUMBER,
        pMember: parsed?.PARENT_CSTMR_NO,
        cMember: parsed?.CHILD_CSTMR_NO,
        pmCheck: parsed?.PM_CHECK,
        appId: parsed?.APP_ID,
      };

      // 교문 CP 로그인 시 추가 파라메타 저장
      if (parsed?.LAUNCH_TYPE === TYPE.ENTRY_TYPE.CP) {
        data = {
          ...data,
          childNm: parsed?.CHILD_NM,
          childYr: parsed?.CHILD_YR,
        };
      }

      if (parsed?.APP_ID) localStorage.setItem("appId", parsed.APP_ID);
    }
  }

  /**
   * entryType, ENTER_TYPE: 채널코드
   * contract, CONTRACT_NUMBER: 계약번호
   * pMember, PMEMBER_CODE: 부모코드
   * cMember, CMEMBER_CODE: 자녀코드
   */
  return data;
};

/**
 * 초를 분으로
 */
export const secondsToMinutes = (seconds) => {
  const hour = parseInt(seconds / 3600);
  const min = parseInt((seconds % 3600) / 60);
  const sec = seconds % 60;

  return { hour, min, sec };
};

/**
 * 0 ~ 100 정확도 타이틀
 */
export const exactlyTitle = (value) => {
  let result = "";
  if (value < 66.6) result = "label1";
  else if (66.6 < value && value < 80) result = "label2";
  else if (80 < value && value < 95) result = "label3";
  else if (95 < value) result = "label4";
  return result;
};

//속도계
export const speedometer = (deviceInfo, id, value, bgColor, barColor) => {
  const c = document.getElementById(id);
  const ctx = c.getContext("2d");
  const _this = document.getElementById(id);
  const _parent = _this.closest(".gaugeBox");
  c.width = _parent.offsetWidth;
  c.height = _parent.offsetHeight;

  let strokeWidth = "0";
  if (deviceInfo.type === TYPE.DEVICE.PHONE) {
    strokeWidth = _parent.getAttribute("data-sw-m");
  } else if (deviceInfo.type === TYPE.DEVICE.PAD) {
    strokeWidth = _parent.getAttribute("data-sw-t");
  } else {
    strokeWidth = _parent.getAttribute("data-sw-pc");
  }

  const x = c.width / 2;
  const y = c.width / 2;
  const radius = c.width / 2 - parseInt(strokeWidth);
  const minRad = 0.75 * Math.PI;
  const maxRad = 2.25 * Math.PI;
  const valueRad = (maxRad - minRad) * value + minRad;

  //background
  ctx.beginPath();
  ctx.arc(x, y, radius, minRad, maxRad);
  ctx.lineWidth = strokeWidth;
  ctx.lineCap = "round";
  ctx.strokeStyle = bgColor;
  ctx.stroke();

  //선이 스르륵 그려지도록 설정
  for (let i = minRad; i < valueRad; i = i + 0.2) {
    if (i + 0.2 > valueRad) {
      setTimeout(
        funcSMlineanim,
        100 * i,
        ctx,
        x,
        y,
        radius,
        minRad,
        valueRad,
        strokeWidth,
        barColor
      );
    } else {
      setTimeout(
        funcSMlineanim,
        100 * i,
        ctx,
        x,
        y,
        radius,
        minRad,
        i,
        strokeWidth,
        barColor
      );
    }
  }

  // 바늘 회전하도록
  /*const _thisArr = _parent.querySelector('.gaugeArr');
  let _thisArrDeg = ( 260 * value ) - 130;
  if(_thisArrDeg < -65 ){
    _thisArrDeg = _thisArrDeg + 20;
  }else if(_thisArrDeg < 0 ){
    _thisArrDeg = _thisArrDeg + 10;
  }
  _thisArr.style.transform = `rotate(${ _thisArrDeg }deg)`;*/
};

function funcSMlineanim(ctx, x, y, radius, minRad, i, strokeWidth, barColor) {
  //foreground
  ctx.beginPath();
  ctx.arc(x, y, radius, minRad, i);
  ctx.lineWidth = strokeWidth;
  ctx.lineCap = "round";
  ctx.strokeStyle = barColor;
  ctx.stroke();
}

// 로티 애니메이션
export const func_animation = (elmID, jsonName, loop, delay) => {
  const tLoop = loop === undefined ? true : loop;
  const _animWrap = document.getElementById(elmID);
  if (!(_animWrap == null)) {
    _animWrap.innerHTML = "";
    const animation = lottie.loadAnimation({
      container: _animWrap,
      renderer: "svg",
      loop: delay ? false : tLoop,
      autoplay: true,
      path: `${process.env.PUBLIC_URL}/static/json/${jsonName}.json`,
    });

    if (delay) {
      animation.addEventListener("complete", function () {
        setTimeout(function () {
          animation.goToAndPlay(0);
        }, delay);
      });
    } else {
      animation.setSpeed(0.65);
    }
  }
};

// 로티 애니메이션 : 특정 구간만 반복 (frameNum부터 끝가지)
export const func_anim_sp = (elmID, jsonName, frameNum) => {
  document.getElementById(elmID).innerHTML = "";
  const animOptions = {
    container: document.getElementById(elmID),
    renderer: "svg",
    loop: false,
    autoplay: true,
    path: "static/json/" + jsonName + ".json",
  };

  const animation = lottie.loadAnimation(animOptions);
  animation.setSpeed(0.6);
  animation.addEventListener("enterFrame", function (e) {
    if (e.currentTime > frameNum - 3) {
      animation.setSpeed(1);
    }
  });

  animation.onComplete = function () {
    animation.goToAndPlay(frameNum, true);
    animation.addEventListener("enterFrame", function (e) {
      if (e.currentTime === e.totalTime - 1) {
        animation.goToAndPlay(frameNum, true);
      }
    });
  };
};

/**
 * 학년별 대주제 > 소주제 default 값
 * @param {String} brthmt: 해당 학습자의 생년월일
 */
export const getStageCodeByGrade = (brthmt) => {
  if (!brthmt) return;
  const { user } = store.getState();

  try {
    const learnerYYYY = moment(brthmt).format("YYYY");
    const nowYYYY = moment().format("YYYY");
    const nowMM = moment().format("MM");

    let code = PROP.STATE_CODE_BY_GRADE.FIRST_SEMESTER;
    if (Number(nowMM) > 6) {
      code = PROP.STATE_CODE_BY_GRADE.SECOND_SEMESTER;
    }

    let age = Number(nowYYYY) - Number(learnerYYYY);
    let find = code[0];

    //글로벌일 때 최대 나이는 중등 이하로 설정
    if (user.info.channelCode === TYPE.CHANNEL.GLOBAL01) {
      if (age >= 13) age = 12;
    }
    /**
     * 주제학습 초기값 설정
     * 나이가 중3(16세) 이상이면 중3 code 값으로
     * 이하이면 7세 code값으로 초기값을 세팅
     */
    if (age + 1 > 16) {
      find = code[code.length - 1];
    } else {
      find = code[0];
    }
    // 7세 이상일 때
    if (age + 1 > 7) {
      const findData = _.find(code, { age: age + 1 });
      if (findData) {
        find = findData;
      }
    }

    return find;
  } catch (error) {
    console.log("##### getStageCodeByGrade: ", error);
  }
};

/**
 * 만 나이
 */
export const getAge = (YYYY) => {
  const nowY = moment().format("YYYY");
  const result = Number(nowY) - Number(YYYY);
  return result;
};

/**
 * 대주세 언어 코드 (THMA_NM_GB_CODE)
 */
export const getThmaNameGBCode = (name) => {
  const data = _.find(PROP.THMA_NM_GB_CODE, ["name", name.replace(/ /g, "")]);
  let code = "";
  if (data) code = data.code;
  return code;
};

/**
 * Table List row number
 */
export const pagingRowNum = (total, size, page, idx) => {
  return total - (page > 1 ? (page - 1) * size + idx : idx);
};

export const appKillFunc = (info) => {
  if (isIOS) {
    window.webkit && window.webkit.messageHandlers.killApp.postMessage("");
  } else {
    window.aicalculator && window.aicalculator.killApp();
  }
};

export const hideLoading = () => {
  if (isIOS) {
    hideSplash();
  } else {
    if (window.aicalculator && window.aicalculator?.hideLoading) {
      window.aicalculator && window.aicalculator.hideLoading();
    }
  }
};

/**
 * 현재 화면이 네이티브 뒤로가기 버튼을 눌렀을 때 종료를 인지 뒤로가기 인지를 알려준다.
 * @param {string} yn: Y(앱이 종료) , N: (앱에서 뒤로가기)
 */
export const appKillOnOff = (yn) => {
  if (isIOS) {
  } else {
    if (window.aicalculator && window.aicalculator.setFirstPage) {
      window.aicalculator.setFirstPage(yn);
    }
  }
};

/**
 * 현재 화면이 네이트브 뒤로가기 버튼을 눌렀을 때 OCR을 켜는지 아니면 뒤로가기 인지를 알려준다.
 * 학습자 ID가 있으면 OCR 켜짐 없으면 뒤로감
 * @param {string} learnerId: 학습자 ID
 */
export const setBackPressedOcr = (learnerId) => {
  if (isIOS) {
  } else {
    if (window.aicalculator && window.aicalculator.setBackPressedOcr) {
      window.aicalculator.setBackPressedOcr(learnerId);
    }
  }
};

/**
 * ai바로셈 splash hidden
 */
export const hideSplash = () => {
  if (isIOS) {
    if (window.webkit && window.webkit.messageHandlers?.hideSplash) {
      window.webkit.messageHandlers.hideSplash.postMessage("");
    }
  } else {
    if (window.aicalculator && window.aicalculator?.hideSplash) {
      window.aicalculator.hideSplash();
    }
  }
};

/**
 * web 브라우저 open
 */
export const openWebBrowser = (url, type) => {

  // if (process.env.REACT_APP_ENV === "local") {
  //   window.open(url)
  //   return;
  // } 

  if (isIOS) {
    if (type === "openInWebBrowser") {
      if (window.webkit && window.webkit?.messageHandlers?.openInWebBrowser) {
        window.webkit.messageHandlers.openInWebBrowser.postMessage(url);
      } else {
        if (process.env.REACT_APP_ENV === "local" || process.env.REACT_APP_ENV === "development") window.open(url)
      }
        
    } else {
      if (window.webkit && window.webkit?.messageHandlers?.openInWebBrowser) {
        window.webkit.messageHandlers.openWebBrowser.postMessage(url);
      } else {
        if (process.env.REACT_APP_ENV === "local" || process.env.REACT_APP_ENV === "development") window.open(url)
      }
    }
  } else {
    if (window.aicalculator && window.aicalculator?.openWebBrowser) {
      window.aicalculator.openWebBrowser(url);
    } else { 
      if (process.env.REACT_APP_ENV === "local" || process.env.REACT_APP_ENV === "development") window.open(url)
    }
    
  }
};

/**
 * ocr open
 */
export const openOcr = (learnerId) => {
  if (isIOS) {
    window.webkit &&
      window.webkit.messageHandlers.openOcr.postMessage(learnerId);
  } else {
    window.aicalculator && window.aicalculator.openOcr(learnerId);
  }
};

/**
 * open start shop
 */
export const openStarShop = (cntrtNo, learnerCode, data) => {
  if (isIOS) {
    // console.log(`{"contractNumber":"${cntrtNo}","customerNumber":"${learnerCode}","orderSeq":"${data}"}`);
    window.webkit &&
      window.webkit.messageHandlers.openStarShop.postMessage(
        `{"contractNumber":"${cntrtNo}","customerNumber":"${learnerCode}","orderSeq":"${data}"}`
      );
  } else {
    window.aicalculator &&
      window.aicalculator.openStarShop(cntrtNo, learnerCode, data);
  }
};

/**
 * open professorK
 */

export const openProfessorK = (learnerCode) => {
  if (isIOS) {
    window.webkit &&
      window.webkit.messageHandlers.openProfessorK.postMessage(learnerCode);
  } else {
    window.aicalculator &&
      window.aicalculator.openProfessorK(learnerCode);
  }
};


export const logoutRemoveStorage = () => {
  // localStorage.removeItem('access.token');
  // localStorage.removeItem('access.starToken');
  localStorage.removeItem("learner.id");
  // localStorage.removeItem('channel.code');

  const isAutoLogin = localStorage.getItem("mathpidLoginChk");

  // amplitude.getInstance().setUserId(null); // not string 'null'
  // amplitude.getInstance().regenerateDeviceId();
  if (isAutoLogin !== "Y") {
    localStorage.removeItem("access.email");
  }
};

export const emailMasking = (email) => {
  if (!email) return "";

  try {
    const [name, domain] = email.split("@");
    const start = name.length > 2 ? 3 : 1;

    return `${name.substring(0, start)}${new Array(
      name.length - (start - 1)
    ).join("*")}@${domain}`;
  } catch (error) {
    console.log(" error : ", error);
    return email;
  }
};

/**
 * 네이티브 appId 추출
 */
export const getAppId = () => {
  let appId = null;

  if (process.env.REACT_APP_ENV === "local") {
    // appId = '97a50897-ca41-4d22-a636-e699ac56f88b1';
    // appId = 'CDCDC81B-7140-4C7C-AA98-05C0009EE118';
    appId = "d8fab93a-dd53-4cc7-bade-6675e2edf456C";
  } else if (process.env.REACT_APP_ENV === "development" && isDesktop) {
    // appId = '97a50897-ca41-4d22-a636-e699ac56f88b';
    appId = "aed5e70f-94d7-47c2-878c-978f02b6bbb9";
  } else {
    if (isIOS) {
      appId = localStorage.getItem("appId");
    } else {
      appId = window.aicalculator && window.aicalculator.getAppId();
    }

    if (process.env.REACT_APP_ENV === 'development' || process.env.REACT_APP_ENV === 'local') {
      if (!appId) appId = localStorage.getItem('appId');
      console.log("***** App ID: ", appId);
    }
  }

  return appId;
};

/**
 * ios appId event
 */
export const setIOSAppId = async () => {
  window.webkit && window.webkit.messageHandlers.getAppId.postMessage("");
};

/**
 * get client ip
 */
export const getClientIp = async () => {
  try {
    const resp = await axios.get("https://api.ipify.org?format=json");
    if (resp && resp.status === 200) {
      return {
        status: resp?.status,
        result: resp?.data,
      };
    } else {
      return {
        status: resp?.status,
        result: {
          ip: null,
        },
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * set subScribe
 */
export const setSubscribe = (productId, m = 500) => {
  if (isIOS) {
  } else {
    try {
      if (window.aicalculator && window.aicalculator?.setSubscribe) {
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve(window.aicalculator.setSubscribe(productId));
          }, m);
        });
      }
    } catch(e) {
      if (process.env.REACT_APP_ENV === "production") {
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve(window.aicalculator.setSubscribe());
          }, m);
        });
      } else {
        throw new Error("error setSubscribe");
      }
    }
  }
};

/**
 * get subScribe
 * @return {string} productId: 상품 ID
 */
export const getSubscribe = async (productId = '') => {

  if (isIOS) {
  } else {
    let res = null;

    try {
      if (window.aicalculator && window.aicalculator?.getSubscribe) {
        res = window.aicalculator.getSubscribe(productId);
        return !_.isEmpty(res) ? JSON.parse(res) : '';
      }
  
      if (process.env.REACT_APP_ENV === "local") {
        return productId === "subscription_1month"
          ? JSON.parse(
              '{"productId":"subscription_1month", "subscribing":"N", "price":"₩15,000", "currencyCode":"KRW"}'
            )
          : productId === "mathpid_subscription_year"
          ? JSON.parse(
              '{"productId":"mathpid_subscription_year", "subscribing":"N", "price":"₩4,990", "currencyCode":"INI"}'
            )
          : '';
      }
      
    } catch(e) {  
      if ( process.env.REACT_APP_ENV === 'production' ) {
        if (window.aicalculator && window.aicalculator?.getSubscribe) {
          res = window.aicalculator.getSubscribe();
          return !_.isEmpty(res) ? JSON.parse(res) : '';
        }
      } else {
        return JSON.parse('{"productId":"", "subscribing":"N", "price":"", "currencyCode":""}');
      }
    }
  }
  return productId;
};

/**
 * request subscribe
 * @param {String} productId
 * @param {String} mbrId
 * @param {String} accessToken
 */
export const requestSubscribe = (productId, mbrId, accessToken) => {
  if (isIOS) {
  } else {
    try {
      if (window.aicalculator && window.aicalculator?.requestSubscribe) {
        return window.aicalculator.requestSubscribe(productId, mbrId, accessToken);
      }
    } catch(e) {
      if ( process.env.REACT_APP_ENV === 'production' ) {
        return window.aicalculator.requestSubscribe(mbrId, accessToken);

      } else {
        throw new Error("error requestSubscribe");
      }
    }
  }
};

export const toDate = (date_str) => {
  // var yyyyMMdd = String(date_str);
  var yyyyMMdd = date_str.substring(0, 8);
  var HHmm = date_str.substring(8, 12);

  return `${yyyyMMdd} ${HHmm}`;
};
/**
 *
 * @param {string} 문자열
 * @returns base64 encoding
 */
export const Base64Encode = (str, encoding = "utf-8") => {
  var bytes = new TextEncoder(encoding).encode(str);
  return base64js.fromByteArray(bytes);
};

/**
 * userAgent
 * @param {*}
 * @returns
 */
export const getUserAgent = (key) => {
  const userAgent = window.navigator.userAgent;
  // const userAgent = "Mozilla/5.0 (iPhone; CPU iPhone OS 14_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148;MATHPID_IOS;x86_64;com.wjthinkbig.ios.mathpid.stg;1.0.0;BRS1000;KO_kr;9;"
  // const userAgent = "Mozilla/5.0 (Linux; Android 11; SM-G977N Build/RP1A.200720.012; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/94.0.4606.85 Mobile Safari/537.36;MATHPID_ANDROID;SM-G977N;com.wjthinkbig.barosem;1.1.5;BRS1000;KR_ko;9"
  const MATHPID_ANDROID_INDEX = isIOS
    ? userAgent.indexOf("MATHPID_IOS")
    : userAgent.indexOf("MATHPID_ANDROID");
  // const CHANNEL_INDEX = userAgent.indexOf(TYPE.CHANNEL.GM_APP);
  let data = "";
  if (MATHPID_ANDROID_INDEX > -1) {
    // data = userAgent.substring(MATHPID_ANDROID_INDEX, CHANNEL_INDEX-1).split(";")
    data = userAgent
      .substring(MATHPID_ANDROID_INDEX, userAgent.length)
      .split(";");
  }

  if (!data) return data;

  switch (key) {
    case "MODEL":
      return data[1];
    case "packageName":
      return data[2];
    case "VERSION_NAME":
      return data[3];
    case "timeZone":
      return data[6];
    case "countryCode":
      return data[5].split("_")[0];
    case "OS_TYPE":
      let os = "WIN";
      if (isAndroid) os = "AND";
      else if (isIOS) os = "IOS";
      return os;
    case "DEVICE_TYPE":
      let deviceType = "";
      if (isBrowser) deviceType = "PC";
      else if (isMobile) deviceType = "SP";
      else if (isTablet) deviceType = "TB";
      return deviceType;
    default:
      return data;
  }
};

/**
 * userAgent
 * @returns Array
 */
export const getUserAgentArr = () => {
  const userAgent = window.navigator.userAgent;
  // const userAgent = "Mozilla/5.0 (iPhone; CPU iPhone OS 14_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148;MATHPID_IOS;x86_64;com.wjthinkbig.ios.mathpid.stg;1.0.0;BRS1000;KO_kr;9;"

  const MATHPID_ANDROID_INDEX = isIOS
    ? userAgent.indexOf("MATHPID_IOS")
    : userAgent.indexOf("MATHPID_ANDROID");
  return MATHPID_ANDROID_INDEX > -1
    ? userAgent.substring(MATHPID_ANDROID_INDEX, userAgent.length).split(";")
    : [];
};

/**
 * 출생년도
 * @param {string} 화면 별 Type 정의, 레벨선택(levelSelection)
 */
export const birthYearsLevel = (type) => {
  const start = Number(moment().subtract("y", 10).format("YYYY"));
  const end = Number(moment().subtract("y", 7).format("YYYY"));
  let result = [];
  let t = 0;

  const levelText = [
    {
      ko: "분수, 소수를 할 수 있어요.",
      en: "I can do fractions and decimals.",
    },
    {
      ko: "곱셈, 나눗셈을 할 수 있어요.",
      en: "I can do multiplication and division.",
    },
    {
      ko: "덧셈, 뺄셈을 할 수 있어요.",
      en: "I can do addition and subtraction.",
    },
    { ko: "1~10까지의 수를 알아요.", en: "I know the numbers from 1 to 10." },
    { ko: "선택안함", en: "unchecked" },
  ];

  for (let i = start; i <= end; i++) {
    const subText = levelText[t][i18next?.language];
    const level = String.fromCharCode([68 - t++]);

    if (_.isEmpty(type)) {
      result.push({
        label: `${
          i18next?.language === "en"
            ? `Level ${level} ${
                isMobile && !isTablet ? `<br/> ${subText}` : ` - ${subText}`
              }`
            : `${level} 단계 ${
                isMobile && !isTablet ? `<br/> ${subText}` : ` - ${subText}`
              }`
        }`,
        subText:
          i18next?.language === "en" ? `Level ${level}` : `${level} 단계`,
        data: i,
      });
    } else {
      if (_.isEqual(type, "levelSelection")) {
        result.push({
          label: subText,
          subText: level,
          data: i,
        });
      }
    }
    // result.push({
    //   label: `${i}${i18next?.language === 'en' ? '' : '년'}`, data: i
    // });
  }
  result = _.reverse(result);
  result.push({
    label: `${levelText[4][i18next?.language]}`,
    data: result[0].data,
    subText: `${levelText[4][i18next?.language]}`,
  });
  return result;
};

/**
 * 학습결과 code string
 */
export const learningResultCode = (code) => {
  //LPSC01: 노력, LPSC02: 기본, LPSC03: 충분, LPSC04: 훌륭
  if (!code) return "";
  switch (code) {
    case "LPSC01":
      return "노력";
    case "LPSC02":
      return "기본";
    case "LPSC03":
      return "충분";
    case "LPSC04":
      return "훌륭";
    default:
      return "";
  }
};

export const myLevel = (birth) => {
  if (!birth) return "";
  const levels = birthYearsLevel();
  const level = _.find(levels, function (o) {
    return String(o.data) === String(birth);
  });
  return level?.subText;
};

/**
 * msaage 영문/한글
 */
export const localeMessage = (msg) => {
  if (typeof msg === "string") {
    return msg;
  } else {
    if (msg?.localeCode) {
      return i18next.t(`front_message.${msg.localeCode}`);
    }
  }
};

/**
 * 이용약관(terms), 개인정보처리방침(privacy), 만14세(adult) 마케팅(marketing)
 *
 */
export const handleTermsPage = (type) => {
  let url = "";
  let title = "";

  const locale = localStorage.getItem("locale");
  const l = locale === "KO" ? "kr" : "en";

  switch (type) {
    case "terms":
      url = `https://wjtb-prd-pub.s3.ap-northeast-2.amazonaws.com/brs/mathpid/html/terms_of_use_${l}.html`;
      title = "이용약관";
      break;
    case "privacy":
      url = `https://wjtb-prd-pub.s3.ap-northeast-2.amazonaws.com/brs/mathpid/html/privacy_policy_${l}.html`;
      title = "개인정보보호방침";
      break;
    case "marketing":
      url = `https://wjtb-prd-pub.s3.ap-northeast-2.amazonaws.com/brs/mathpid/html/marketing_consent_${l}.html`;
      title = "마케팅 수신 동의";
      break;
    default:
      break;
  }
  try {
    openWebBrowser(url);
  } catch (error) {
    window.open(url, title);
  }
};

export const translationKoMsg = (code) => {
  if (!code) return;
  const msg = translationKO.API_ERROR[code];

  return msg ? msg : translationKO.API_ERROR["S000001"];
};

/**
 * @param {string} email: 이메일 text
 * @returns 이메일 양식이 맞으면 true 아니면 false
 */
export const emailRegExp = (email) => {
  const re =
    /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/;
  return re.test(email);
};

/**
 * @param {string} pwd: 비밀번호
 * @return 영문, 순자, 특문 포함 8글자 이상이면 true 아니면 false
 */
export const passwordRegExp = (pwd) => {
  const re =
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[~!@#$%^&*()_+])[A-Za-z\d~!@#$%^&*()_+]{8,}$/;
  return re.test(pwd);
};
/**
 *
 * @param {string} phone: 핸드폰 번호
 * @returns - 없는 핸드폰 양식에 맞으면 true 아니면 false
 */
export const phoneRegExp = (phone) => {
  return /^0[0-1]{2}[0-9]{3,4}[0-9]{4}$/.test(phone);
};
/**
 *
 * @param {string} birth: 생년월일
 * @returns 생년월일 6자리가 맞으면 true 아니면 false
 */
export const birthRegExp = (birth) => {
  return /([0-9]{2}(0[1-9]|1[0-2])(0[1-9]|[1,2][0-9]|3[0,1]))/.test(birth);
};

// SET 화면 진입 수
export const setUserViewCount = (path) => {
  const { user } = store.getState();
  const { channelCode } = user?.info;

  const gbViewCountObj = JSON.parse(localStorage.getItem("gb_view_count"));
  const gbView = gbViewCountObj?.[path];

  let paramObj = null;
  let initCount = 0;

  if (channelCode === TYPE.CHANNEL.GLOBAL01) {
    if (gbView) {
      paramObj = {
        ...gbViewCountObj,
        [path]: {
          ...gbView,
          count: gbView.count + 1, // 1 증가
          isShowPopup: (parseInt(gbView.count) + 1) % 5 === 0,
        },
      };
    } else {
      paramObj = {
        ...gbViewCountObj,
        [path]: {
          ...gbView,
          count: initCount,
          isShowPopup: true,
        },
      };
    }
    // console.log("paramObj", paramObj);
    localStorage.setItem("gb_view_count", JSON.stringify(paramObj));
  }
};

// GET 화면 진입 수
export const checkPayPopup = (path) => {
  const { user } = store.getState();
  const { channelCode } = user?.info;

  if (channelCode === TYPE.CHANNEL.GLOBAL01) {
    return JSON.parse(localStorage.getItem("gb_view_count"))?.[path]
      ?.isShowPopup;
  }
  return false;
};

export const handlePayment = ({ info, history, Alert, language }) => {
  const { userId: mbrId = "", subscribing = "", storeProductID = ""} = info || {};

  // 플레이스토어 계정 'Y' 인경우
  if (_.isEqual(subscribing, "Y")) {
    Alert(
      `${
        language === "ko"
          ? "이미 결제된 Playstore ID 입니다.<br/>결제 시 사용했던 매쓰피드 ID로 로그인하시거나 Playstore에서 환불 후,<br/>앱을 다시 실행해주세요"
          : "Your Google Play ID is already subscribed to Mathpid Premium.<br/>Please login with the Mathpid ID(Email) you used to purchased the subscription.<br/>Or Refund at Google Play and restart the Mathpid app."
      }`
    );
    return null;
  }

  const accessToken = localStorage.getItem("access.token");

  if (!_.isEmpty(mbrId) && !_.isEmpty(accessToken)) {
    if (
      process.env.REACT_APP_ENV === "development" ||
      process.env.REACT_APP_ENV === "local"
    ) {
      console.log("payment prductId : ", storeProductID);
      console.log("payment mbrId : ", mbrId);
      console.log("payment accessToken : ", accessToken);
    }

    if(storeProductID) {
      requestSubscribe(storeProductID, mbrId, accessToken); // 결제요청
    } else {
      requestSubscribe(mbrId, accessToken); // 결제요청(이전버젼)
    }
    
  } else {
    // 예외처리
    Alert(t("error.msg001"), () => {
      history.push(URL.SELECT_LEARNING);
    });
  }
};